import { SectionHeaderCellProps } from '../../types';
import { Box } from '@mui/material';

const TotalsSectionCell = ({ _customRowProps }: SectionHeaderCellProps) => {
  return <Box>Totals</Box>;
};

export default TotalsSectionCell;
